<template>
  <Catalogs
    title="Категории занятости"
    create-text="Новая"
    :fetch-data="fetchData"
    :route-create="'EmploymentCategoryAdd'"
    :route-edit="'EmploymentCategoryEdit'"
    :route-view="'EmploymentCategoryView'"
    :route-path="'/employment_categories'"
    :can-edit="canEditEmploymentCategoryCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
import permissions, {PERM} from "../../../utilites/permissions";
import Catalogs from "../Catalogs.vue";

export default {
  name: "EmploymentCategories",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  methods: {
    async fetchData(data) {
      return await this.getEmploymentCategories(data);
    },
    canEditEmploymentCategoryCatalogs() {
      return this.hasPermission([PERM.CATALOG_DEPARTMENT_EDIT]);
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/EmploymentCategories/EmploymentCategories.vue